import React from 'react';
import { FaExternalLinkAlt, FaArrowRight, FaPaperPlane, FaExclamationTriangle } from 'react-icons/fa';

const ActionButtonsRenderer = ({ data, onButtonClick }) => {
  const { message, buttons } = data;

  const getButtonIcon = (iconName) => {
    const icons = {
      'external-link': FaExternalLinkAlt,
      'arrow-right': FaArrowRight,
      'send': FaPaperPlane,
      'warning': FaExclamationTriangle
    };
    const IconComponent = icons[iconName];
    return IconComponent ? <IconComponent className="text-xs" /> : null;
  };

  const getButtonStyles = (style) => {
    const styles = {
      'primary': 'bg-blue-600 text-white border-blue-600 hover:bg-blue-700',
      'secondary': 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200',
      'danger': 'bg-red-600 text-white border-red-600 hover:bg-red-700'
    };
    return styles[style] || styles.secondary;
  };

  const handleButtonClick = (button) => {
    if (button.action === 'link' && button.url) {
      window.open(button.url, '_blank');
    } else if (button.action === 'send_message' && button.message) {
      onButtonClick?.(button);
    } else if (button.action === 'api_call' && button.apiEndpoint) {
      onButtonClick?.(button);
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      {/* Message */}
      <div className="p-4 border-b border-gray-200">
        <p className="text-gray-700">{message}</p>
      </div>

      {/* Action buttons */}
      <div className="p-4">
        <div className="flex flex-wrap gap-2">
          {buttons.map((button) => (
            <button
              key={button.id}
              onClick={() => handleButtonClick(button)}
              className={`
                px-4 py-2 rounded-lg border font-medium text-sm transition-colors
                flex items-center space-x-2
                ${getButtonStyles(button.style)}
              `}
            >
              {button.icon && getButtonIcon(button.icon)}
              <span>{button.label}</span>
              {button.action === 'link' && <FaExternalLinkAlt className="text-xs" />}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ActionButtonsRenderer;
